{
  "slug": "low-iq-scores-explained",
  "title": "কম আইকিউ স্কোরের কারণগুলোকে দায়িত্বশীলভাবে ব্যাখ্যা করা হয়েছে",
  "description": "বুঝতে হবে নিম্ন আইকিউ স্কোর রেঞ্জ, বিশ্বাসের ব্যবধান, অনুকূল কার্যকারিতা, এবং কেন একটি স্কোর একাই কখনও একজন ব্যক্তিকে সংজ্ঞায়িত করে না বা একটি রোগ নির্ণয় করে না।",
  "summary": "নিম্ন IQ ফলাফল একটি নির্বাচিত কাজের একটি নরম গ্রুপের তুলনায় কার্যকারিতা বর্ণনা করে। এটির জন্য সতর্কতা, সম্মানজনক ব্যাখ্যার প্রয়োজন, অনিশ্চয়তা, প্রবেশাধিকার প্রয়োজন, উন্নয়ন এবং দৈনন্দিন কার্যকারিতা।",
  "category": "IQ স্কোর ব্যাখ্যা",
  "sections": [
    {
      "heading": "নিম্ন স্কোরের অর্থ কি হতে পারে এবং হতে পারে না",
      "paragraphs": [
        "একটা...100, এসডি-15 স্কেল, স্কোর নিচে 85 জনসংখ্যার গড়ের নিচে এবং স্কোরের কাছে 70 এর চেয়ে কম হলেও দুইটি মানদণ্ডের ব্যবধানের মধ্যে থাকে । সঠিক পরিমাপ ও শ্রেণীবিভাগ নির্ভর করে যন্ত্র এবং নিয়মের ওপর ।",
        "এই ফল মানব মূল্য, দয়া, সৃজনশীলতা, বাস্তব অভিজ্ঞতা, বা সব ক্ষমতার পরিমাপ করে না। ভাষা, শিক্ষা, সংবেদনশীল বা মোটর ব্যবহার, স্বাস্থ্য, মনোযোগ এবং পরীক্ষার পরিবেশ কর্মক্ষমতাকে প্রভাবিত করতে পারে।"
      ]
    },
    {
      "heading": "শুধুমাত্র আই. কিউ. থেকে রোগ নির্ণয় করা যায় না",
      "paragraphs": [
        "বুদ্ধিবৃত্তিক প্রতিবন্ধকতার পেশাদার মূল্যায়ন বুদ্ধিবৃত্তিক কার্যকারিতাকে ধারণার, সামাজিক এবং বাস্তব জীবনের ক্ষেত্রে সঙ্গতিপূর্ণ কার্যকারিতা সহ বিবেচনা করে, যা বিকাশের সময় শুরু হয়।",
        "একজন যোগ্য মূল্যায়ক উপযুক্ত পদক্ষেপ বেছে নেন, আরাম ও পটভূমি বিবেচনা করেন, বিশ্বাসের ব্যবধান পরীক্ষা করেন এবং একাধিক উৎস থেকে তথ্য একত্রিত করেন।"
      ]
    },
    {
      "heading": "সমর্থনের প্রয়োজন বুঝতে ফলাফল ব্যবহার করুন",
      "paragraphs": [
        "গঠনমূলক প্রশ্ন হচ্ছে কোন কাজ সহজ আর কোনটা কঠিন এবং কোন ধরনের সহায়তা অংশগ্রহণ বৃদ্ধি করে।",
        "যদি কোন পরীক্ষার ফল অপ্রত্যাশিত হয় বা সেবা প্রদানে প্রভাব ফেলতে পারে, তাহলে অনলাইনে পরীক্ষা নেওয়ার পরিবর্তে বা কোন পরীক্ষার ফলাফলকে সম্পূর্ণ সঠিক বলে মনে করার পরিবর্তে, একটি যোগ্য পেশাদার ব্যক্তির সাথে আলোচনা করুন।"
      ]
    }
  ],
  "faqs": [
    {
      "question": "IQ এর নিচে? 70 বুদ্ধিবৃত্তিক প্রতিবন্ধকতা?",
      "answer": "না, রোগ নির্ণয়ের জন্য প্রয়োজন হয়, রোগীর আচরণের ওপর পর্যালোচনা এবং তার বিকাশের ইতিহাস, যথাযথ পেশাদার মানদণ্ড ব্যবহার করে।"
    },
    {
      "question": "পরীক্ষার শর্ত কি স্কোর কমাতে পারে?",
      "answer": "হ্যাঁ, ক্লান্তি, অসুস্থতা, উদ্বেগ, ভাষার মিল না থাকা, মনোযোগ বিভ্রাট, প্রবেশের বাধা এবং অন্যান্য অবস্থা কর্মক্ষমতাকে প্রভাবিত করতে পারে।"
    }
  ],
  "related": ["iq-80-meaning", "iq-score-ranges-explained", "how-is-iq-measured"],
  "sources": [
    {
      "label": "এআইডিডি – বুদ্ধিবৃত্তিক প্রতিবন্ধী প্রশ্ন ও উত্তর",
      "url": "https://www.aaidd.org/docs/default-source/intellectualdisability/12th-ed-twenty-questions-faq.pdf"
    },
    {
      "label": "পিয়ারসন - WAIS-5 নমুনা স্কোর রিপোর্ট",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    }
  ]
}
